import * as React from "react";
import { User } from "../../userTypes";
import { Button, Tooltip } from "@material-ui/core";
import ThumbUp from "@material-ui/icons/ThumbUp";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
  onClick: (params?: any) => any;
  disabled: boolean;
  fetchingData: boolean;
};

const theme = createMuiTheme({
  palette: {
    primary: green,
  },
  typography: {
    useNextVariants: true,
  },
});

export default class ManualVerificationAcceptButton extends React.Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    return this.props.disabled === false &&
      this.props.fetchingData === false ? (
      <MuiThemeProvider theme={theme}>
        <Button
          color="primary"
          variant="contained"
          className="button no-margin"
          onClick={this.props.onClick}
          disabled={this.props.disabled}
        >
          Verify user
          <ThumbUp
            style={{
              marginLeft: "10px",
            }}
          />
        </Button>
      </MuiThemeProvider>
    ) : (
      <Tooltip
        title="There must be a manual verification request associated with the user, with a status of in_review, for them to be verified."
        placement="bottom-start"
      >
        <span>
          <MuiThemeProvider theme={theme}>
            <Button
              color="primary"
              variant="contained"
              className="button no-margin"
              onClick={this.props.onClick}
              disabled={this.props.disabled}
            >
              Verify user
              <ThumbUp
                style={{
                  marginLeft: "10px",
                }}
              />
            </Button>
          </MuiThemeProvider>
        </span>
      </Tooltip>
    );
  }
}
